//  ViewTests.js
//
//  Updated 2/2.
//
//  Abstract: Create new tests functional component. CRUD Firestore and Firebase.

//	React
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import axios from 'axios';
import { authMiddleware } from '../../../services/auth/auth.js';

// Components
import ViewIndividualTest from './ViewIndividualTest/ViewIndividualTest.js';
import ViewMultipleTests from './ViewMultipleTests/ViewMultipleTests.js';

//	Material-ui components
import { AppBar, Tabs, Tab, Box, Typography, CircularProgress, Card, CardActions, CardContent, Divider, Button, Grid, TextField, makeStyles, FormControl, Select, InputLabel, MenuItem, Container, Paper } from '@material-ui/core';


//	CSS Styles
const useStyles = makeStyles((theme) => ({
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
        marginTop: '100px'
    },
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
    paper: {
        flex: 0
        // minHeight: '500px !important'
    },
    details: {
        display: 'flex'
    },
    avatar: {
        height: 110,
        width: 100,
        flexShrink: 0,
        flexGrow: 0
    },
    locationText: {
        paddingLeft: '15px'
    },
    buttonProperty: {
        position: 'absolute',
        top: '50%'
    },
    uiProgess: {
        position: 'fixed',
        zIndex: '1000',
        height: '31px',
        width: '31px',
        left: '50%',
        top: '35%'
    },
    progess: {
        position: 'absolute'
    },
    uploadButton: {
        marginLeft: '8px',
        margin: theme.spacing(1)
    },
    customError: {
        color: 'red',
        fontSize: '0.8rem',
        marginTop: 10
    },
    submitButton: {
        marginTop: '10px'
    }
}));

export default function ViewTests(props) {

    //  CSS styles
    const classes = useStyles();

    //	Set state
    const [patientId, setPatientId] = useState('');
    const [testId, setTestId] = useState('');
    const [patchIdsArray, setPatchIdsArray] = useState([]);
    const [plannedTestStartDate, setPlannedTestStartDate] = useState('');
    const [errors, setErrors] = useState([]);
    const [isUiLoading, setIsUiLoading] = useState(false);
    const [isButtonLoading, setIsButtonLoading] = useState(false);
    const [value, setValue] = useState(0);
    const [selectedDate, setSelectedDate] = useState(new Date('2014-08-18T21:11:54'));
    const [tests, setTests] = useState([]);

    //	Event handlers
    const handleDateChange = (date) => {
        setSelectedDate(date);
    };
    function handlePatientIdChange(event) {
        setPatientId(event.target.value);
    }
    function handleTestIdChange(event) {
        setTestId(event.target.value);
    }
    function handlePatchIdsArrayChange(event) {
        setPatchIdsArray(event.target.value);
    }
    function handlePlannedTestStartDateChange(event) {
        setPlannedTestStartDate(event.target.value);
    }
    function handleErrorsChange(event) {
        setErrors([event.target.value]);
    }
    function handleValueChange(event, newValue) {
        setValue(newValue);
    };
    function handleCreateTestSubmit(event) {
        authMiddleware(props.history);
        event.preventDefault();
        const testData = {
            patientId: patientId,
            testId: testId,
            patchIdsArray: patchIdsArray,
            plannedTestStartDate: plannedTestStartDate
        };
        let options = {};
        options = {
            url: `/test`,
            method: 'post',
            data: testData
        }
        const authToken = localStorage.getItem('AuthToken');
        axios.defaults.headers.common = { Authorization: `${authToken}` };
        axios(options)
            .then(() => {
            })
            .catch((error) => {
                setErrors(error.response.data)
                console.log(error);
            });
    };



    var myFirstRow = [];

    // function getTestsRequest() {
    //     authMiddleware(props.history);
    //     const authToken = localStorage.getItem('AuthToken');
    //     axios.defaults.headers.common = { Authorization: `${authToken}` };
    //     axios.get('/tests').then((response) => {
    //         // setTests(response.data);
    //         var myFirstTest = response.data[0];
    //         myFirstRow.push({
    //             id: 1,
    //             // id: myFirstTest.testId,
    //             lastName: myFirstTest.patientId,
    //             firstName: myFirstTest.patchIdsArray,
    //             age: myFirstTest.createdAt
    //         })
    //     }).catch((err) => {
    //         console.log(err);
    //     });
    // }

    // On component mount(load)
    // useEffect(() => {


    //     // console.log(tests)
    // }, []);



    // const handleSave = (newdata) => {
    //     axios
    //       .put(window.urls.save, this.state.layout)
    //       .then(
    //         function(response) { // i want this to change in hooks
    //              setLayout(response.data);               
    //              setSaving(false);
    //              this.refs["preview"].refresh();
    //         }.bind(this)
    //       )
    //       .catch(
    //         function(error) {
    //           console.log(error);
    //           setSaving(false);
    //         }.bind(this)
    //       );
    //   }
    
    
    useEffect(() => {
        //  function getData() {
        //     const response = await fetch('/data/nodes.csv')
        //     const reader = response.body.getReader()
        //     const result = await reader.read() // raw array
        //     const decoder = new TextDecoder('utf-8')
        //     const csv = decoder.decode(result.value) // the csv text
        //     const results = Papa.parse(csv, { header: true }) // object with { data, errors, meta }
        //     const rows = results.data // array of objects
        //     setRows(rows)
        // }

        async function getTestsRequest() {
            authMiddleware(props.history);
            const authToken = localStorage.getItem('AuthToken');
            axios.defaults.headers.common = { Authorization: `${authToken}` };
            axios.get('/tests').then((response) => {
                setTests(response.data);
                var myFirstTest = response.data[0];
                myFirstRow.push({
                    id: 1,
                    // id: myFirstTest.testId,
                    lastName: myFirstTest.patientId,
                    firstName: myFirstTest.patchIdsArray,
                    age: myFirstTest.createdAt
                })
            }).catch((err) => {
                console.log(err);
            });
        }

        
        // getData()

        // getTestsRequest();
        // console.log(tests)
    }, []);
        

    //     setLayout(newdata);
    //     setSaving(true);
    // if (newData) handleSave(newData) },[newData,saving])
    



    // { id: 1, lastName: 'Snow', firstName: 'Jon', age: 35 },

    // const myTests = jsonToStrMap(tests[0]);
    // console.log(tests)



    function strMapToObj(strMap) {
        let obj = Object.create(null);
        for (let [k,v] of strMap) {
          // We don’t escape the key '__proto__'
          // which can cause problems on older engines
          obj[k] = v;
        }
        return obj;
      }
      function objToStrMap(obj) {
        let strMap = new Map();
        for (let k of Object.keys(obj)) {
          strMap.set(k, obj[k]);
        }
        return strMap;
      }

    function strMapToJson(strMap) {
        return JSON.stringify(strMapToObj(strMap));
      }

      function jsonToStrMap(jsonStr) {
        return objToStrMap(JSON.parse(jsonStr));
      }

    //	Define tab picker
    function TabPanel(props) {
        const { children, value, index, ...other } = props;
        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && (
                    <Box p={3}>
                        <Typography>{children}</Typography>
                    </Box>
                )}
            </div>
        );
    }

    TabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.any.isRequired,
        value: PropTypes.any.isRequired,
    };

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    //	Render loading screen
    if (isUiLoading) {
        return (
            <main className={classes.content}>
                <div className={classes.toolbar} />
                {isUiLoading && <CircularProgress size={16} className={classes.uiProgess} />}
            </main>
        );
    } else {
        //	Render tab view of individual and batch tests
        return (
            <Container>
                {/* <Paper className={classes.paper}> */}
                <main className={classes.content}>
                    <div className={classes.root}>
                        <AppBar position="static" elevation={0} >
                            <Tabs value={value} onChange={handleValueChange} aria-label="tab-picker">
                                <Tab label="Test Directory" {...a11yProps(0)} disableRipple />
                                <Tab label="Test" {...a11yProps(1)} disableRipple  />
                            </Tabs>
                        </AppBar>
                        <TabPanel value={value} index={0}>
                            <ViewMultipleTests myFirstRow={tests}/>
                            {/* <CreateIndividualTest isButtonLoading={isButtonLoading} patientId={patientId} testId={testId} patchIdsArray={patchIdsArray} plannedTestStartDate={plannedTestStartDate} errors={errors} onPatientIdChange={handlePatientIdChange} onTestIdChange={handleTestIdChange} onPatchIdsArrayChange={handlePatchIdsArrayChange} onPlannedTestStartDateChange={handlePlannedTestStartDateChange} onErrorsChange={handleErrorsChange} onCreateTestSubmit={handleCreateTestSubmit} /> */}
                        </TabPanel>
                        <TabPanel value={value} index={1} >
                            <ViewIndividualTest />
                            {/* <CreateBatchTests /> */}
                        </TabPanel>
                    </div>
                </main>
                {/* </Paper> */}
            </Container>
        );
    }
};